import { ITableCellEventHandlers, TableCellComponent } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/table/table-cell-component';
import { InterfaceFactoryOptions } from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/elements/factory-options.interface';
import { ITableCellModel, ITableModel } from '@src/slide/domain/ui-model/element-modeles/Interface/table-model.interface';

export interface ITableCellWrapperEventHandlers extends ITableCellEventHandlers {
    revertPickCell: () => void;
    renderCellBackground: () => void;
    tableOtherPartMakeCache: () => void;
    updateBigTableMode: () => void;
    onUpdateComponent: () => void;
}

/**
 * 大表格附加层
 * 当前类为单元格的附加逻辑，即当表格的单元格数量超过一定限度时会启用大表格模式
 * 体现为 单击单元格时会把当前单元格单独提出来，把表格的其他单元格整体缓存，编辑完成后再将此单元格还回去
 * 为了达到此效果会重写一些方法，但是在一般场景下无需关心这些逻辑
 * 可以理解为 单元格的正常逻辑均在table-cell-component！！！！！
 */
export class TableCellComponentWrapper extends TableCellComponent {
    declare protected eventHandlers?: ITableCellWrapperEventHandlers;

    public constructor(factoryOptions: InterfaceFactoryOptions<ITableModel>, cellModel: ITableCellModel) {
        super(factoryOptions, cellModel);
        this.eventHandlers?.updateBigTableMode();
    }

    public setEventHandlers(eventHandlers: ITableCellWrapperEventHandlers) {
        this.eventHandlers = eventHandlers;
    }

    public updateComponent(cellModel): void {
        super.updateComponent(cellModel);
        this.eventHandlers?.onUpdateComponent();
    }
}
